document.addEventListener("DOMContentLoaded", function () {
    wcStickyHeader();
});

function wcStickyHeader() {
    const mainContent = document.getElementById('MainContent');

    if (!mainContent) return;

    const header = document.createElement('header');
    header.id = 'wc-sticky-header';

    const stickyHeader = document.getElementById('wc-sticky-header');
    if (stickyHeader) return;

    mainContent.before(header);

    const headerShopify = document.getElementById('shopify-section-header');
    const announcementBar = document.getElementById('shopify-section-announcement-bar');
    const menu = document.getElementById('shopify-section-header-mega-menu');

    if (!headerShopify || !announcementBar) return;
    header.appendChild(announcementBar);
    header.appendChild(headerShopify);

    if (!menu) return;
    header.appendChild(menu);
}
window.addEventListener('scroll', () => {
    document.body.classList.toggle('scrolled', window.scrollY > 10);
});


document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('a[href^="http"]:not([href*="' + location.hostname + '"])').forEach(l => {
      l.target = '_blank';
      l.rel = 'noopener';
    });
  });


document.addEventListener("DOMContentLoaded", function () {
    const filters = document.querySelectorAll('form#FacetFiltersForm details');

    filters.forEach((filter, index) => {
        const span = filter.querySelector('summary > div > span');
        if (!span) return;

        const clone = span.cloneNode(true);
        clone.querySelector('.facets__selected')?.remove();
        const txt = clone.textContent?.trim()?.toLocaleLowerCase();

        if (txt == 'product type') {
            const lis = filter.querySelectorAll('fieldset ul:first-of-type li');
            if (lis.length == 1) {
                filter.style.display = 'none';
            }
        }
    });

    const filters2 = document.querySelectorAll('form#FacetFiltersFormMobile details');
    filters2.forEach((filter, index) => {
        const span = filter.querySelector('summary > div > span');
        if (!span) return;

        const clone = span.cloneNode(true);
        clone.querySelector('.facets__selected')?.remove();
        const txt = clone.textContent?.trim()?.toLocaleLowerCase();

        if (txt == 'product type') {
            const lis = filter.querySelectorAll('.mobile-facets__submenu ul:first-of-type li');
            if (lis.length == 1) {
                filter.style.display = 'none';
            }
        }
    });

});

(() => {
    let found = false;
    let attempts = 0;
    const maxAttempts = 20;
    const intervalTime = 250;

    const interval = setInterval(() => {
        if (!found) {
            const element = document.querySelector('input[type="radio"][name="Color"]');
            if (element) {
                clearInterval(interval);
                found = true;
                setTimeout(function () {
                    document.querySelectorAll('input[type="radio"][name="Color"]').forEach(radio => {
                        radio.addEventListener('change', (e) => {
                            wcScrollToTop();
                        });
                    });
                }, 500);
            }
        }
        if (attempts >= maxAttempts) {
            clearInterval(interval);
        }
        attempts++;
    }, intervalTime);

function isInViewport(ele) {
    const { top, bottom } = ele.getBoundingClientRect();
    const header = document.querySelector('header#wc-sticky-header');
    if (header) {
        return bottom - header.offsetHeight > 0 && top < window.innerHeight;
    }
    else {
        return bottom > 0 && top < window.innerHeight;
    }
}

    function wcScrollToTop() {
        if (window.screen.availWidth > 750) return;

        const slider = document.querySelector('.product__media-slider');
        if (!slider) return;

        if (isInViewport(slider)) return;

        setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }, 500);
    }
})();


document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 786) {
document.querySelectorAll('ul.product-grid li.grid__item .product-card').forEach(function (element) {
    const button = document.createElement('button');
    button.className = 'mobile-quick-addto-cart';
    button.textContent = 'ADD +';
    element.append(button);
});

document.querySelectorAll('section.featured-collection swiper-container swiper-slide').forEach(function (element) {
    const button = document.createElement('button');
    button.className = 'mobile-quick-addto-cart';
    button.textContent = 'ADD +';
    element.append(button);
});

document.querySelectorAll('button.mobile-quick-addto-cart').forEach(function (button) {
    button.addEventListener('click', function (e) {
        e.preventDefault();

        const parent = this.closest('.product-card, .grid__item');

        if (!parent) return;

        const smallHide = parent.querySelector('.card__inner > .small-hide');

        if (!smallHide) return;

        smallHide.style.setProperty('display', 'block', 'important');

        const quickAddBar = parent.querySelector('.quick-add-bar');

        if (quickAddBar) {
            quickAddBar.style.visibility = 'visible';
            quickAddBar.style.opacity = '1';
        }

        const quickAdd = smallHide.querySelector('quick-add');

        if (!quickAdd) return;


        let closeBtn = quickAdd.querySelector('.close-quick-add');

        if (!closeBtn) {
            closeBtn = document.createElement('div');
            closeBtn.classList.add('close-quick-add');
            closeBtn.textContent = '×';

            quickAdd.prepend(closeBtn);

            closeBtn.addEventListener('click', function (e) {
                e.stopPropagation();

                smallHide.style.setProperty('display', 'none', 'important');

                if (quickAddBar) {
                    quickAddBar.style.visibility = 'hidden';
                    quickAddBar.style.opacity = '0';
                }
            });
        }
    });
});

    }
});


const wcGetColorsSwatchesImagesCss = () => {
 const cards = document.querySelectorAll('.product-card');
 const getColor = target => {
 const colorsObserver = new IntersectionObserver((entries, observer) => {
 entries.forEach(entry => {
 if (entry.isIntersecting) {
 const otherColorsEl = entry.target.querySelector('.other-colors');
 if (otherColorsEl.classList.contains('colors-images-found')) return true;

 const myStyle = otherColorsEl.getAttribute('data-product-style');
 if (!myStyle || myStyle === 'false') {
 observer.disconnect();
 return;
 }

 fetch(`/search?q=${encodeURIComponent(myStyle)}&type=product&view=product-swatches`)
 .then(response => response.text())
 .then(data => {
 const doc = new DOMParser().parseFromString(data, 'text/html');
 const style = doc.querySelector('style');

 if (!style) {
 console.log('No style found');
 return;
 }
 wcAddSwatchesImagesCss(style.textContent, myStyle)
 otherColorsEl.classList.add('colors-images-found');

 });
 observer.disconnect();
 }
 });
 });
 colorsObserver.observe(target)
 };
 cards.forEach(getColor);
}
wcGetColorsSwatchesImagesCss();


function wcAddSwatchesImagesCss(css, title) {
 css = css.replace(
 /\.product-form__input\[data-option\s*=\s*["']Color["']\]\s+input\[value\s*=\s*["']([^"']+)["']\]\s*\+\s*label\s*\{([^}]*)\}/g,
 (match, color, properties) => {
 const imageMatch = properties.match(/background-image\s*:\s*([^;]+);/);

 if (!imageMatch) return '';

 const imageUrl = imageMatch[1].replace(/\.(png|jpg|jpeg|webp)(\?.*)?$/i, '_25x.$1$2');

 return `button.product-color[data-title="${title}"][data-color="${color}"] { background-image: ${imageUrl} !important;}`;
 }
 );

 css = css.replace(/\.product-form__input\[data-option\s*=\s*["']Color["']\]\s+input:checked\s*\+\s*label\s*\{[^}]*\}/g, '');

 css = css.replace(/\n\s*\n+/g, '\n\n').trim();
 if (title == 'Jenny Mini Dress') {
    let count = 0;
    css = css.replace(/button\.product-color\[data-title="Jenny Mini Dress"\]\[data-color="Black"\]\s*\{[^}]*\}/g, (match) => {
        count++; return count === 2 ? '' : match;
    });
}

 const newStyle = document.createElement('style');
 newStyle.textContent = css;
 document.head.appendChild(newStyle);
}


(() => {
 const getOtherColors = () => {
 const cards = document.querySelectorAll('.product-card');
 const getColor = target => {
 const colorsObserver = new IntersectionObserver((entries, observer) => {
 entries.forEach(entry => {
 if (entry.isIntersecting) {
 const otherColorsEl = entry.target.querySelector('.other-colors');
 if (otherColorsEl.classList.contains('colors-swatches-added')) return true;

 const myStyle = otherColorsEl.getAttribute('data-product-style');

 if (!myStyle || myStyle === 'false') {
 observer.disconnect();
 return;
 }

 fetch(`/search?q=${myStyle}&type=product&view=api`)
 .then(response => response.json())
 .then(data => {
 const items = [];
 data.forEach(item => {
 const itemStyle = item.title.split(' - ')[0];
 if (itemStyle !== myStyle) return true;
 items.push(item);
 });
 wcRenderColorSwatches(target, items);
 otherColorsEl.classList.add('colors-swatches-added');
 });
 observer.disconnect();
 }
 });
 });
 colorsObserver.observe(target)
 };
 cards.forEach(getColor);
 }
 getOtherColors();


function wcRenderColorSwatches(card, items) {

 if (items.length < 2) return;
 const ul = document.createElement('ul');
 ul.classList.add('product-colors');

 items.forEach(item => {
 const li = document.createElement('li');
 const button = document.createElement('button');

 const title = item.title.split(' - ')[0];
 const color = item.title.split(' - ')[1];

 button.classList.add('product-color');

 button.style.backgroundColor = color;
 button.style.backgroundSize = 'cover';
 button.style.backgroundPosition = 'center';
 button.style.backgroundRepeat = 'no-repeat';


 button.title = item.title;
 button.dataset.title = title;
 button.dataset.color = color;
 button.dataset.item = JSON.stringify(item);

 button.addEventListener('click', event => {
 if (!event.target.classList.contains('active')) {
 wcColorClick(event, card);
 }
 });

 li.appendChild(button);
 ul.appendChild(li);
 });

 const div = document.createElement('div');
 div.classList.add('product-colors-wrapper');
 div.appendChild(ul);

 if (items.length > 6) {
 const buttonLeft = document.createElement('button');
 buttonLeft.className = 'scroll-button scroll-left';
 buttonLeft.disabled = true;
 buttonLeft.addEventListener('click', event => {
 wcScrollButtonClick(event);
 });

 buttonLeft.innerHTML = ` <svg viewBox="0 0 24 24" focusable="false">
 <path d="M0 0h24v24H0z" fill="none"></path> 
 <path d="M8.59,16.59L13.17,12L8.59,7.41L10,6l6,6l-6,6L8.59,16.59z"></path>
 </svg> `;

 div.appendChild(buttonLeft);


 const buttonRight = document.createElement('button');
 buttonRight.className = 'scroll-button scroll-right';
 buttonRight.addEventListener('click', event => {
 wcScrollButtonClick(event);
 });

 buttonRight.innerHTML = ` <svg viewBox="0 0 24 24" focusable="false">
 <path d="M0 0h24v24H0z" fill="none"></path> 
 <path d="M8.59,16.59L13.17,12L8.59,7.41L10,6l6,6l-6,6L8.59,16.59z"></path>
 </svg> `;

 div.appendChild(buttonRight);
 }

 card.insertBefore(div, card.children[2]);
 card.classList.add('wc-colors-added');
 wcSelectDefaultColor(card);
}



function wcSelectDefaultColor(card) {
 if (!card) return;
 const sizes = [];
 const sizeRadios = card.querySelectorAll('form.quick-add-bar__form fieldset[data-option="Size"] .quick-add__radio');
 Array.from(sizeRadios).forEach((radio, index) => {
 const button = radio.querySelector('button');
 if (!button) return;
 const buttonTxt = button.textContent;
 const size = button.textContent?.trim();
 if (size === '') return;

 if (size.includes("Add To Bag")) return;

 if (!sizes.includes(size)) {
 sizes.push(size);
 }
 });
 card.dataset.sizes = JSON.stringify(sizes);

 const image = card.querySelector(window.innerWidth > 750 ? '.card__media .media > img' : '.swiper-wrapper .swiper-slide img');

 if (!image?.src) return;

 const imageFileName = wcGetImageFileName(image.src);


 if (!imageFileName) return;

 const imageWithoutExt = imageFileName.substring(0, imageFileName.lastIndexOf('.'));

 const colors = card.querySelectorAll('ul.product-colors li button');

 if (colors.length === 0) return;

 for (const color of colors) {

 const item = JSON.parse(color.dataset?.item);

 if (!item?.media) continue;

 let colorImages;

 try {
 colorImages = item.media;
 } catch {
 continue;
 }

 if (!Array.isArray(colorImages)) continue;

 for (const colorImage of colorImages) {

 const colorImageFileName = wcGetImageFileName(colorImage?.src);

 if (!colorImageFileName) continue;

 const lastDot = colorImageFileName.lastIndexOf('.');

 if (lastDot === -1) continue;

 const colorImageWithoutExt = colorImageFileName.substring(0, lastDot);

 if (imageFileName.includes(colorImageWithoutExt)) {
 color.classList.add('active');
 return;
 }
 }
 }
}


 function wcScrollButtonClick(event) {
 //console.log('%c event.currentTarget ', 'color: red;', event.currentTarget);
 const container = event.currentTarget.closest('.product-colors-wrapper');
 const list = container.querySelector('ul');

 const scrollAmount = 100;
 const direction = event.currentTarget.classList.contains('scroll-left') ? -1 : 1;

 const currentPosition = list.scrollLeft;
 const newPosition = currentPosition + (scrollAmount * direction);


 list.scrollBy({
 left: scrollAmount * direction,
 behavior: 'smooth'
 });

 setTimeout(() => {
 const maxScroll = list.scrollWidth - list.clientWidth;

 const leftButton = container.querySelector('.scroll-button.scroll-left');
 const rightButton = container.querySelector('.scroll-button.scroll-right');

 leftButton.disabled = false;
 rightButton.disabled = false;

 if (newPosition <= 0) {
 leftButton.disabled = true;
 rightButton.disabled = false;
 } else if (newPosition >= maxScroll) {
 leftButton.disabled = false;
 rightButton.disabled = true;
 }

 }, 500);
 }


function wcColorClick(event, card) {
 if (!event.currentTarget?.dataset?.item) return;
 const item = JSON.parse(event.currentTarget.dataset?.item);

 const id = item?.id;
 const media = item.media.slice(0, 3);
 const handle = item?.handle;
 const variants = item?.variants;


 const sizes = JSON.parse(card.dataset.sizes || '[]');
 Array.from(variants).forEach((variant, index) => {
 const size = sizes.find((size) => variant.options.includes(size));
 if (size) {
 variant.size = size;
 }
 });


 const form = card.querySelector('form.quick-add-bar__form');
 if (form) {
 form.setAttribute('id', `quick-add-form--${id}`);
 }

 const colorRadio = card.querySelector('form.quick-add-bar__form fieldset[data-option="Color"] .quick-add__radio');
 if (colorRadio) {
 colorRadio.dataset.variantId = variants.at(-1).id;
 const button = colorRadio.querySelector('button');
 button.dataset.variantId = variants.at(-1).id;
 }

 const sizeRadios = card.querySelectorAll('form.quick-add-bar__form fieldset[data-option="Size"] .quick-add__radio');
 Array.from(sizeRadios).forEach((radio, index) => {
 let sizeFound = false;
 const button = radio.querySelector('button');
 if (!button) return;
 const buttonTxt = button.textContent;

 if (sizes.length > 0) {
 button.classList.add('sold-out');
 }


 const size = button.textContent?.trim();
 if (size === '') return

 const variant = variants[index] ?? null;

 if (buttonTxt.includes('Add To Bag')) {
 radio.dataset.variantId = variants[0].id;
 button.dataset.variantId = variants[0].id;
 if (variants[0].available) {
 button.classList.remove('sold-out');
 }
 else {
 button.classList.add('sold-out');
 }
 }
 else {
 if (size === variant?.size) {

 if (variant.available) {
 button.classList.remove('sold-out');
 }
 radio.dataset.variantId = variants[index].id;
 button.dataset.variantId = variants[index].id;
 }
 else {
 Array.from(variants).forEach((variant, index) => {
 if (size === variant?.size) {
 if (variant.available) {
 button.classList.remove('sold-out');
 }
 radio.dataset.variantId = variants[index].id;
 button.dataset.variantId = variants[index].id;
 }
 });
 }
 }
 });

 const images = card.querySelectorAll(window.innerWidth > 750 ? '.card__media .media > img' : '.swiper-wrapper .swiper-slide img');
 Array.from(images).forEach((img, index) => {
 if (media[index]) {
 const mediaImage = media[index];
 img.srcset = wcCreateSrcset(mediaImage.src, mediaImage.width);
 img.src = mediaImage.src;
 img.dataset.src = mediaImage.src;

 img.width = mediaImage.width;
 img.height = mediaImage.height;
 }
 });


 const anchors = card.querySelectorAll('a');
 Array.from(anchors).forEach((anchor, index) => {
 anchor.href = `/products/${handle}`;
 });

 card.querySelectorAll('.product-color').forEach((button) => { button.classList.remove('active'); });
 event.currentTarget.classList.add('active');


 const isOnSale = item.compare_at_price != null && item.compare_at_price > item.price;
 const formatter = new Intl.NumberFormat('en-US', {
 style: 'currency', currency: Shopify.currency.active, minimumFractionDigits: 2, maximumFractionDigits: 2,
 });

 const priceWrapper = card.querySelector('.card-information >.price');
 const regularEle = card.querySelector('.price__regular');
 const saleEle = card.querySelector('.price__sale');

 if (isOnSale) {

 if (!saleEle) return;
 const regularPriceEle = saleEle.querySelector('.price-item--regular');
 const salePriceEle = saleEle.querySelector('.price-item--sale');

 if (!regularPriceEle || !salePriceEle) return

 const regularPrice = formatter.format(item.compare_at_price / 100);
 const salePrice = formatter.format(item.price / 100);


 regularPriceEle.textContent = Shopify.currency.active == 'USD' ? regularPrice.replace(".00", "") : regularPrice;
 salePriceEle.textContent = Shopify.currency.active == 'USD' ? salePrice.replace(".00", "") : salePrice;
 saleEle.style.display = 'flex';
 regularEle.style.display = 'none';
 priceWrapper.classList.add('price--on-sale');


 }
 else {
 if (!regularEle) return;

 const regularPriceEle = regularEle.querySelector('.price-item--regular');
 if (!regularPriceEle) return
 const regularPrice = formatter.format(item.price / 100);

 regularPriceEle.textContent = Shopify.currency.active == 'USD' ? regularPrice.replace(".00", "") : regularPrice;
 saleEle.style.display = 'none';
 regularEle.style.display = 'flex';
 priceWrapper.classList.remove('price--on-sale');
 }
}





 function wcGetImageFileName(url) {
 if (!url) return '';
 try {
 const fullUrl = url.startsWith('//') ? `https:${url}` : url;
 return new URL(fullUrl).pathname.split('/').pop() || '';
 } catch (error) {
 return '';
 }
 }
 function wcGetShopifyImageUrl(url, width) {
 const imageUrl = new URL(url.startsWith('//') ? `https:${url}` : url);
 imageUrl.searchParams.set('width', width);
 return imageUrl.toString();
 }

 function wcCreateSrcset(url, originalWidth = 533) {
 const widths = [165, 360, 533, 720, 940, 1066];
 const srcset = widths.filter((width) => width < originalWidth).map((width) => {
 return `${wcGetShopifyImageUrl(url, width)} ${width}w`;
 });
 srcset.push(`${wcGetShopifyImageUrl(url, originalWidth)} ${originalWidth}w`);
 return srcset.join(', ');
 }
})();


(() => {
    let found = false;
    let attempts = 0;
    const maxAttempts = 20;
    const intervalTime = 500;

    const interval = setInterval(() => {
        if (!found) {
            const element = document.querySelector('body.template-product variant-radios > fieldset[data-option="Color"] input[type=radio]');
            if (element) {
                clearInterval(interval);
                found = true;
                const element = document.querySelector('body');
                document.body.dispatchEvent(new CustomEvent('colorVariantsLoaded'));
                getVariants();
            }
        }
        if (attempts >= maxAttempts) {
            clearInterval(interval);
        }
        attempts++;
    }, intervalTime);


    function getVariants() {
        const title = document.querySelector('body.template-product h1.product__title');
        if (!title) return;
        const titleTxt = title.textContent.trim();

        fetch(`/search?q=${titleTxt}&type=product&view=api`)
            .then(response => response.json())
            .then(data => {
                const items = [];
                data.forEach(item => {
                    const itemStyle = item.title.split(' - ')[0];
                    if (itemStyle !== titleTxt) return true;
                    items.push(item);
                });
                addInfoToColorVariants(items);
            })
            .catch((error) => { console.log('%c error ', 'color: red;', error); });

        function addInfoToColorVariants(items) {
            items.forEach(item => {
                if (item?.variants?.length) {
                    item.color = item.variants[0]?.option1;
                }
            });

            const colorRadios = document.querySelectorAll('variant-radios > fieldset.product-form__input[data-option="Color"] input[type=radio]');
            if (!colorRadios) return;
            Array.from(colorRadios).forEach(radio => {

                const product = items.find(item => item.color === radio.value);
                radio.dataset.product = JSON.stringify(product);
                if (product.compare_at_price) {
                    radio.closest('.variant-radio').classList.add('sale-available');
                }
            });
        }
    }
})();



// Quick Add Form Handler
      document.addEventListener('submit', (event) => {
        const form = event.target.closest('.cart-drawer-upsell .upsell-slide-item form.upsell-form');
        if (!form) return;
        event.preventDefault();

        const input = form.querySelector('input[name="id"]');
        if (!input) return;

        const variantId = input.value;
        if (!variantId) return;

        wcAddToCart(variantId, 1, form);
      });

      function wcAddToCart(variantId, quantity = 1, form = null) {
        if (form) form.classList.add('is-loading');
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{ id: Number(variantId), quantity: quantity }],
                sections: 'cart-drawer,cart-icon-bubble',
                sections_url: window.location.pathname
            })
        })
        .then(response => response.json())
        .then(parsedState => {
            if (form) form.classList.remove('is-loading');
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
                cartDrawer.renderContents(parsedState);
            }
        })
        .catch(error => {
            if (form) form.classList.remove('is-loading');
            console.error(error);
        });
      }


document.addEventListener('click', (event) => {
    const btn = event.target.closest('.remove-cart-item');
    if (!btn) return;
    event.preventDefault();

    const item = btn.closest('li.drawer__content-item');
    if (!item) return;

    const variantId = item.dataset.variantId;
    if (!variantId) return;

    wcRemoveFromCart(variantId)
});

function wcRemoveFromCart(variantId) {

    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id: variantId,
            quantity: 0,
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname
        })
    })
        .then(response => response.json())
        .then(cart => {
            document.querySelector('cart-drawer')?.renderContents(cart);
        })
        .catch(error => {
            console.error(error);
        });
}

document.addEventListener('click', function (e) {
    const empty_drawer_a = e.target.closest('cart-drawer .drawer_empty a');
    if (!empty_drawer_a) return;

    const close_drawer_a = document.querySelector('cart-drawer button.drawer__close');
    if (!close_drawer_a) return;

    e.preventDefault();
    close_drawer_a.click();
});


      // Arrow Click Handler
      document.addEventListener('click', (event) => {
        const arrowBtn = event.target.closest('.upsell-arrow-btn');
        if (!arrowBtn) return;

        const upsellSection = arrowBtn.closest('.cart-drawer-upsell');
        if (!upsellSection) return;

        const track = upsellSection.querySelector('.upsell-slider-track');
        if (!track) return;

        const container = track.parentElement;
        const slideItem = track.querySelector('.upsell-slide-item');
        const scrollAmount = slideItem ? slideItem.offsetWidth + 10 : 150;

        if (arrowBtn.classList.contains('upsell-prev')) {
          container.scrollLeft -= scrollAmount;
        } else if (arrowBtn.classList.contains('upsell-next')) {
          container.scrollLeft += scrollAmount;
        }
      });


      (function () {
  var lastPath = location.pathname;

  async function syncBadge() {
    if (location.pathname === lastPath) return;
    lastPath = location.pathname;
    try {
      var res = await fetch(location.pathname + location.search);
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-extra40-badge]');
      var current = document.querySelector('[data-extra40-badge]');
      if (current && fresh) current.innerHTML = fresh.innerHTML;
    } catch (e) {}
  }

  ['pushState', 'replaceState'].forEach(function (method) {
    var original = history[method];
    history[method] = function () {
      var result = original.apply(this, arguments);
      setTimeout(syncBadge, 0);
      return result;
    };
  });
  window.addEventListener('popstate', syncBadge);
})();